import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.has('lang')) {
  urlParams.delete('lang');
  const newPath = window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : '');
  window.history.replaceState({}, document.title, newPath);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister service workers to avoid stale cache or unsupported MIME type errors
serviceWorkerRegistration.unregister();

